import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ApiCollectionResponse } from '../app/app.interfaces';
import { Observable } from 'rxjs';
import { from } from 'rxjs/observable/from';
import { map } from 'rxjs/operators';
import { EventService } from './event.service';

@Injectable()
export class ChatService {
  
  private pollingIntervalID: any = null;
  private pollingIntervalUserID: string = null;
  private pollingFilters: any;
  
  constructor(private apiService: ApiService,
              private eventService: EventService) {
  }

  sendMessage(message: string, toUserId: string, attachments: any = []): Promise<any> {
    return this.apiService.createResource('direct_messages', {
      to: toUserId,
      content: message,
      attachments: attachments
    });
  }
  
  getMessages(userId: string = null, filters: any = {}): Observable<ApiCollectionResponse> {
    if (!filters) {
      filters = {};
    }
    if (userId) {
      filters.with = userId;
    }
    filters['order[id]'] = 'DESC';
    return from(this.apiService.getCollection('direct_messages', filters)).pipe(
      map(response => {
        response.items = response.items.reverse();
        return response;
      })
    );
  }
  
  getAdminMessages(filters?: any): Observable<ApiCollectionResponse> {
    filters['order[id]'] = 'ASC';
    return from(this.apiService.getCollection('direct_messages/admin', filters)).pipe(
      map(response => {
        response.items = response.items.reverse();
        return response;
      })
    );
  }
  
  setDirectMessage(id: number, data: any): Observable<any> {
    return from(this.apiService.resourceCustomPut('', 'direct_messages/' + id, data));
  }
  
  removeDirectMessage(id: number): Observable<any> {
    return from(this.apiService.customDelete( 'direct_messages/' + id));
  }
  
  getMessagesFromPage(userId: string, page: string, filters: any = {}): Observable<ApiCollectionResponse> {
    if (userId) {
      filters.with = userId;
    }
    if (!filters['order[id]']) {
      filters['order[id]'] = 'DESC';
    }
    return from(this.apiService.getCollection(page, filters)).pipe(
      map(response => {
        response.items = response.items.reverse();
        return response;
      })
    );
  }
  
  getConversations(): Observable<ApiCollectionResponse> {
    return from(this.apiService.getCollection('direct_messages/conversations'));
  }
  //
  // /**
  //  * Starts polling direct messages (restarts if there's a polling event active)
  //  *
  //  * @param withUserId
  //  * @param filters
  //  * @param pollingInterval
  //  */
  // startPollingDirectMessages(withUserId: string, filters: any, pollingInterval: number) {
  //   if (this.pollingIntervalID) {
  //     if(this.pollingIntervalUserID === withUserId) {
  //       // We're already polling messages for this user; do nothing
  //       return;
  //     } else {
  //       // We switched user; cancel the current interval
  //       clearInterval(this.pollingIntervalID);
  //     }
  //   }
  //
  //   this.pollingFilters = filters;
  //   this.pollingIntervalUserID = withUserId;
  //   this.pollingIntervalID = setInterval(() => {
  //     this.getMessages(withUserId, this.pollingFilters).subscribe(response =>
  //       response.items.length > 0 ? this.eventService.receivedDirectMessages.emit(response.items) : null);
  //   }, pollingInterval);
  // }
  //
  // stopPollingDirectMessages(withUserId: string) {
  //   if(this.pollingIntervalUserID === withUserId) {
  //     clearInterval(this.pollingIntervalID);
  //   } else {
  //     // We arent currently polling for user id
  //   }
  // }
  
  setPollingFilters(filters: any) {
    this.pollingFilters = filters;
  }
}



// WEBPACK FOOTER //
// ./src/services/chat.service.ts